// extracted by mini-css-extract-plugin
export default {"container":"register-page_container__ZIWEK","formContainer":"register-page_formContainer__wBbuk","form":"register-page_form__kpL0o","link":"register-page_link__9jq0L"};